import { ThemeProvider } from '@sparemin/blockhead';
import cn from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import ClipSelectEditViewContainer from 'blocks/ClipSelect/components/ClipSelectEditViewContainer';
import EddyEmbed, { EddyElement } from 'blocks/EddyEmbed';
import BemCssTransition from 'components/BemCssTransition';
import bem from 'utils/bem';
import { useClipSelectAnimation } from '../ClipSelectAnimationContext';
import { useClipSelect } from '../ClipSelectContext';
import { useClipSelectNavigation } from '../ClipSelectNavigationContext';

export interface ClipSelectTranscriptEditorProps {
  className?: string;
}

const block = bem('clip-select-transcript-editor');

const ClipSelectTranscriptEditor: React.FC<ClipSelectTranscriptEditorProps> = ({
  className,
}) => {
  const { eddyProjectId, onSelectClip, onTranscriptUpdate } = useClipSelect();

  const [, send] = useClipSelectNavigation();

  const animations = useClipSelectAnimation();

  const [eddy, setEddy] = useState<EddyElement>(null);

  // this is a simplification of navState - the effect below needs more data than
  // just whether or not the transcript editor is active, so it inspects navState
  // directly
  const isActive = animations.transcript.in;

  const handleClipSelect = useCallback(
    async clip => {
      send({ type: 'EDITOR_CLOSE' });

      await onSelectClip({ region: clip });

      animations.onClipSelected();
    },
    [animations, onSelectClip, send],
  );

  useEffect(() => {
    if (!isActive && eddy) {
      // this will run more often than necessary but should be harmless to pause
      // an already-paused player
      eddy.pause();
    }
  }, [eddy, isActive]);

  return (
    <ThemeProvider theme="dark">
      <BemCssTransition
        className={cn(block(), className)}
        {...animations.transcript}
      >
        <ClipSelectEditViewContainer>
          {eddyProjectId && (
            <EddyEmbed
              className={block('transcript')}
              eddyProjectId={eddyProjectId}
              height="100%"
              onClipSelect={handleClipSelect}
              onTranscriptUpdate={onTranscriptUpdate}
              ref={setEddy}
              width="100%"
            />
          )}
        </ClipSelectEditViewContainer>
      </BemCssTransition>
    </ThemeProvider>
  );
};

export default ClipSelectTranscriptEditor;
